import React, { useState } from 'react';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { ButtonsListContainer } from 'components/Button';
import { IStyle } from 'Styles';

interface Props {
  text: string;
  updateAnnotationText: (text: string) => void;
  hideModal: () => void;
}

const UpdateAnnotationText = (props: Props) => {
  const { text, updateAnnotationText, hideModal } = props;
  const [annotationText, setAnnotationText] = useState<string>(text);

  const actionButtons: RMCustomButtonProps[] = [
    {
      title: 'YES, PROCEED',
      contentContainerClass: 'bg-[#F7A246] w-[9.5rem] !text-[#ffffff] h-full',
      buttonMainContainerStyle: styles.actionButtonStyles,
      onClick: () => {
        updateAnnotationText(annotationText);
        hideModal();
      },
    },
    {
      title: 'CANCEL',
      contentContainerClass: 'btn-outline-yellow-wide h-full',
      buttonMainContainerStyle: styles.actionButtonStyles,
      onClick: () => hideModal(),
    },
  ];

  return (
    <div id='updateannotationtext-wrapper' className="d-flex flex-column">
      <textarea
        id='updateannotationtext-minvalue-text'
        className="textArea w-full h-[150px] resize-none"
        name="minValue"
        value={annotationText}
        onChange={(e) => setAnnotationText(e.target.value)}
      />
      <ButtonsListContainer
        containerStyleClass="my-3 justify-end"
        marginBetweenItems={4}
        buttonsList={actionButtons}
      />
    </div>
  );
};

export default UpdateAnnotationText;

const styles: IStyle = {
  actionButtonStyles: {
    display: 'flex',
    textTransform: 'uppercase',
    height: '2rem',
    minHeight: '2rem',
    maxHeight: '2rem',
    fontSize: '1rem',
    borderRadius: '0.375rem',
  },
};
